import { ShowPersonioSetupRowsResponseSchema } from './show-personio-setup-rows.schema';
export const showPersonioSetupRowsContract = {
    method: 'GET',
    path: '/api/v2/data-sync/personio/setup-rows',
    description: 'Show the initial-setup rows seeded from the stored data-sync snapshot',
    responseSchema: ShowPersonioSetupRowsResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            401: 'Unauthorized - user not authenticated',
            403: 'Forbidden - not allowed to manage the data source'
        }
    }
};

//# sourceMappingURL=show-personio-setup-rows.contract.js.map